import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

// Forwards ?partner=<name> across /f2 child route navigations so the
// partner logo stays visible throughout the full checkout journey.
export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.query.partner && from.query.partner) {
    return navigateTo({
      ...to,
      query: { ...to.query, partner: from.query.partner },
    })
  }

  return undefined
})
